import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { FormInput } from '../../components/FormInput';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { checkDpSuccess } from '../../utility/service/tool-service';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import { queryFeUsersList, suspendFeUsersInfo, unlockUserAccount } from '../../utility/service/account-service';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { CusCompanyAcctList } from './CusCompanyAcctList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const CompanyList_Acct = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [,loading] = useContext(SystemLoading);
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([]);
    const [userSeq ,setUserSeq ] = useState('');
    const [delDialog,setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const isEditable = useEditableFlag('B10201'); // control edit by B10201
    
    
    
    
    const esgClientId = [
        {
            label:t('company.a'),
            value:'A'
        },
        {
            label:t('company.b'),
            value:'B'
        }
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            keywordSearch:'',
            companyType:''
        },
        //錯誤驗證時機
        mode: "all"
      });

    const onSubmit = (data)=>{
        let reqBody = {
          keywordSearch:data.keywordSearch,
        }
        if(data.companyType!==''){
          reqBody.companyType = data.companyType
        }
        axios_queryFeUsersList(reqBody);
        
    }

    const btnBackTo = ()=>{
        navigate("/management/companyList")
    }

    const confirmDel =()=>{
      suspendFeUsersInfo({userSeq:delObj?.userSeq})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
            let reqBody = {
              keywordSearch:getValues("keywordSearch"),
            }
            if(getValues("companyType")!==''){
              reqBody.companyType = getValues("companyType")
            }
            reqBody.companyType =itemObj?.type || itemObj?.companyType;
            reqBody.companySeq = itemObj?.companySeq;
            axios_queryFeUsersList(reqBody);
            setDelDialog(false);
          }
        })
    }

     //查詢更多
    const btnReadMore = () => {
      let reqBody = {
        userSeq:userSeq,
        companyType:itemObj?.type || itemObj?.companyType,
        companySeq: itemObj?.companySeq
      }
      axios_queryFeUsersList(reqBody,true);
    };

    const editItem = (item,act)=>{
      setItemObj(item);
      navigate(act);
      setAction(act);
    }

    const deleteItem = (item)=>{
      setDelDialog(true);
      setDelObj(item);
    }

    const unlockItem = (item)=>{
      unlockUserAccount({userSeq:item?.userSeq})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.unlock') + ' ' + t('message.success'));
            axios_queryFeUsersList({
              companyType:item?.companyType,
              companySeq: item?.companySeq
            });
            
          }
        })
    }

    useEffect(()=>{
        if(action!==''){
            axios_queryFeUsersList({
                companyType:itemObj?.type || itemObj?.companyType,
                companySeq: itemObj?.companySeq
            });
        }else{
            btnBackTo();
        }
    },[])

    const axios_queryFeUsersList = (reqBody,readMore=false)=>{
      checkLoading(loading);
      queryFeUsersList(reqBody)
        .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.userList;
              if(data?.length > 0){
                setUserSeq(data[data?.length-1].userSeq);
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      }).finally((fin)=>{checkLoading(loading,false);})
  }



  return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
    <div className="align-items-start">
        <Button rounded text onClick={() => { btnBackTo(); }}>
        <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
        {t('button.return_to_list')}
        </Button>
    </div>
    </div>
    <CusCompanyAcctList 
      rows={rows} 
      btnReadMore={btnReadMore} 
      editItem={editItem} 
      delDialog={delDialog} 
      setDelDialog={setDelDialog}
      confirmDel={confirmDel}
      delObj={delObj}
      deleteItem={deleteItem}
      unlockItem={unlockItem}
      isType="N"
      isEditable={isEditable}>

      {t('org_name')}: {itemObj?.name || itemObj?.companyName}  
   

    </CusCompanyAcctList>
    </>
    
  )
}

export default CompanyList_Acct